module.exports = __webpack_public_path__ + "img/img-risk-sec-03-02.png";